var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M69,54.79,71.25,40H57.08V30.44c0-4,2-8,8.33-8h6.44V9.9a78.48,78.48,0,0,0-11.44-1C48.75,8.9,41.12,16,41.12,28.77V40h-13V54.79h13V90.48a51.67,51.67,0,0,0,16,0V54.79Z"}));
}

Facebook.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 100 100"};

module.exports = Facebook;

Facebook.default = Facebook;
